var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"error-page"}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('404.message'))+" "),_c('span',{staticClass:"error-link",on:{"click":_vm.backRoute}},[_vm._v(_vm._s(_vm.$t('404.backlink')))]),_vm._v(". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }